export function daysForLocale(locale = 'en-GB', weekday = 'short') {
    const format = new Intl.DateTimeFormat(locale, { weekday, timeZone: 'UTC' }).format;
    return [1, 2, 3, 4, 5, 6, 7].map(day => format(new Date(Date.UTC(2021, 2, day))));
}
